import { render, staticRenderFns } from "./CtrlNohinsaki.vue?vue&type=template&id=83be7852&"
import script from "./CtrlNohinsaki.vue?vue&type=script&lang=ts&"
export * from "./CtrlNohinsaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports